@if (formGroup) {
  <ng-container [formGroup]="formGroup">
    <ng-container *ngTemplateOutlet="datepicker" />
  </ng-container>
} @else {
  <ng-container *ngTemplateOutlet="datepicker" />
}

<ng-template #datepicker>
  <app-form-control
    [isRequired]="isRequired"
    [label]="label"
    [hasErrors]="hasErrors"
    class="datepicker-wrapper full-width"
    [class.with-time]="showTime"
    [class.plain]="plainView"
    [max-width]="cxMaxWidth"
  >
    <div #datePickerWrapper class="full-width">
      <div class="input-wrapper full-width">
        <div
          (click)="isPickerOpened = true"
          class="cursor-pointer date-input input d-flex align-items-center white-space-nowrap {{ hasErrors ? 'input-error' : '' }}"
          [class.disabled]="isDisabled"
          [class.focus]="isPickerOpened"
        >
          @if (isRangePicker) {
            {{ (range.from ? (range.from | dayjsFormat:'DD.MM.YYYY') : ('Start date' | trans:'datepicker/input.StartDateLabel')) + ' - ' + (range.to ? (range.to | dayjsFormat:'DD.MM.YYYY') : ('End date' | trans:'datepicker/input.EndDateLabel')) }}
          }

          @if (isKWPicker) {
            {{ (selectedCinemaWeek.week ? ('KW ' + selectedCinemaWeek.week + '; ' + (selectedCinemaWeek.from | dayjsFormat:'DD.MM.YYYY') + ' - ' + (selectedCinemaWeek.to | dayjsFormat:'DD.MM.YYYY')) : this.placeholder) }}
          }

          @if (selectedVal && !isKWPicker && !isRangePicker) {
            @if (pickerType === 'day' && !showTime) {
              <ng-container *ngTemplateOutlet="dayInputView" />
            } @else {
              <ng-container *ngTemplateOutlet="showTimeDayPlaceholder" />
            }

            <ng-template #showTimeDayPlaceholder>
              @if (pickerType !== 'month') {
                {{ selectedVal | dayjsFormat:'DD.MM.YYYY' }}
              }
            </ng-template>

            @if (pickerType === 'month') {
              {{ selectedVal | dayjsFormat:'MMMM YYYY' }}
            }

            @if (pickerType === 'year') {
              <ng-container *ngTemplateOutlet="yearInputView" />
            }
          }

          @if (!selectedVal) {
            @if (pickerType === 'year') {
              <ng-container *ngTemplateOutlet="yearInputView" />
            }

            @if (pickerType === 'day' && !showTime) {
              <ng-container *ngTemplateOutlet="dayInputView" />
            }

            @if (!isKWPicker) {
              {{ this.placeholder }}
            }
          }

          @if (selectedVal && showTime && selectedTime) {
            {{ (selectedTime | dayjsFormat:'; HH:mm') }}
          }
        </div>
        <i class="ri-calendar-event-line icon"></i>
      </div>
      <ng-template #pickerLayer>
        <div [class.enlarged-picker]="enlargePickerLayer"
          class="picker-layer p-16 picker-layer--{{ theme }} picker-layer--{{ pickerType }}"
          [class.picker-layer--shows]="isForShows"
        >
          <div class="choice-view">
            <div class="d-flex justify-content-center gap-8 choice-view__header full-width">
              @if (!(isDayMonthView && currentChoiceMode === choiceModes.MONTHS)) {
                <button
                  class="icon-button sm m-l-12 c-t-blue-700"
                  (click)="arrowClick(true)"
                  type="button"
                >
                  <i class="ri-arrow-drop-left-line"></i>
                </button>
              }

              <div class="text m-x-4 d-flex align-items-center white-space-nowrap justify-content-center">
                @if (currentChoiceMode === choiceModes.DAYS || currentChoiceMode === choiceModes.RANGE || currentChoiceMode === choiceModes.KW) {
                  <p
                    class="t1 m-r-8"
                    (click)="changeCurrentChoiceMode(choiceModes.MONTHS)"
                  >
                    {{ currentDateToShow | dayjsFormat:'MMMM' }}
                  </p>
                }

                @if (!isDayMonthView) {
                  <p
                    class="t1"
                    [class.pointer-events-none]="currentChoiceMode === choiceModes.YEARS"
                    (click)="changeCurrentChoiceMode(choiceModes.YEARS)"
                  >
                    {{ currentDateToShow | dayjsFormat:'YYYY' }}
                  </p>
                }
              </div>

              @if (!(isDayMonthView && currentChoiceMode === choiceModes.MONTHS)) {
                <button
                  class="icon-button sm m-r-12 c-t-blue-700"
                  (click)="arrowClick()"
                  type="button"
                >
                  <i class="ri-arrow-drop-right-line"></i>
                </button>
              }
            </div>

            @switch (currentChoiceMode) {
              @case (choiceModes.DAYS) {
                <ng-container *ngTemplateOutlet="daysView"></ng-container>
              }
              @case (choiceModes.MONTHS) {
                <ng-container *ngTemplateOutlet="monthsView"></ng-container>
              }
              @case (choiceModes.YEARS) {
                <ng-container *ngTemplateOutlet="yearsView"></ng-container>
              }
              @case (choiceModes.RANGE) {
                <ng-container *ngTemplateOutlet="rangeView"></ng-container>
              }
              @case (choiceModes.KW) {
                <ng-container *ngTemplateOutlet="kwView"></ng-container>
              }
            }
          </div>

          <div
            class="d-flex buttons align-items-center gap-16 m-t-12 {{ isKWPicker ? 'justify-content-end' : '' }}"
          >
            @if (!isRequired) {
              <button class="button button--sm button--secondary flex-grow-1" (click)="close(false)" type="button">
                <span>{{ 'Close' | trans:'datepicker/buttons/close.Label' }}</span>
              </button>
            }

            @if (!showTime) {
              <button class="button button--sm button--secondary flex-grow-1" (click)="backToToday()" type="button">
                <span>{{ 'Today' | trans:'datepicker/today-button.Text' }}</span>
              </button>
            }

            @if (showTime) {
              <button class="button secondary flex-grow" (click)="close(true)" type="button">
                <span>{{ 'Bestätigen' | trans:'datepicker/confirm-button.Text' }}</span>
              </button>
            }
          </div>
        </div>
      </ng-template>
    </div>

    <ng-content select="[errors]" errors></ng-content>
  </app-form-control>
</ng-template>

<ng-template #daysView>
  <div class="view">
    <div class="d-flex justify-content-center week-days">
      @for (day of weekDays; track day) {
        <div class="day-box">
          {{ day }}
        </div>
      }
    </div>

    <div class="separator"></div>

    <div class="days d-flex flex-wrap">
      @for (date of datesToRender; track i; let i = $index;) {
        <button
          type="button"
          [disabled]="(minDate && ((date.date | cloneDeep | dayjsStartOf:'day') < (minDate | cloneDeep | dayjsStartOf:'day'))) || (maxDate && ((date.date | cloneDeep | dayjsStartOf:'day') > (maxDate | cloneDeep | dayjsStartOf:'day')))"
          class="day-box"
          [class.selected]="selectedVal && (date.date | dayjsFormat:'DD.MM.YYYY') === (selectedVal | dayjsFormat:'DD.MM.YYYY')"
          [class.day-box--today]="date.isToday"
          [class.day-box--next-month]="date.isNextMonth"
          [class.day-box--last-month]="date.isLastMonth"
          [class.day-box--sunday]="date.isSunday"
          [class.day-box--current-month]="date.isCurrentMonth"
          [class.day-box--has-shows]="isForShows && (showsStore.shows() | showsByDate:date.date).length > 0"
          (click)="dateChange(date.date)"
        >
          {{ date.date | dayjsFormat:'DD' }}
        </button>
      }
    </div>

    @if (showTime) {
      <div class="separator"></div>

<!--      <cx-timepicker-->
<!--        [label]="'Time' | trans: (namespace + 'time-picker.Label')"-->
<!--        [(ngModel)]="selectedTime"-->
<!--        (ngModelChange)="onTimeChange()"-->
<!--      ></cx-timepicker>-->
    }
  </div>
</ng-template>

<ng-template #rangeView>
  <div class="view">
    <div class="d-flex justify-content-center week-days range">
      @for (day of weekDays; track day) {
        <div class="day-box">
          {{ day }}
        </div>
      }
    </div>
    <div class="separator"></div>

    <div class="days d-flex flex-wrap">
      @for (date of datesToRender; track i; let i = $index;) {
        <button
          type="button"
          [disabled]="(minDate && ((date.date | dayjsFormat:'x') < (minDate | dayjsFormat:'x'))) || (maxDate && ((date.date | dayjsFormat:'x') > (maxDate | dayjsFormat:'x')))"
          class="day-box"
          [class.disabled]="!date.isCurrentMonth"
          [class.selected]="((range.from && ((date.date | dayjsFormat:'DD.MM.YYYY') === (range.from | dayjsFormat:'DD.MM.YYYY'))) || (range.to && ((date.date | dayjsFormat:'DD.MM.YYYY') === (range.to | dayjsFormat:'DD.MM.YYYY'))))"
          [class.in-range]="((range.from && range.to) && ((date.date | dayjsFormat:'x') >= (range.from | dayjsFormat:'x') && (date.date | dayjsFormat:'x') <= (range.to | dayjsFormat:'x')))"
          [class.from]="(range.from && (date.date | dayjsFormat:'x') === (range.from | dayjsFormat:'x'))"
          [class.to]="(range.to && (date.date | dayjsFormat:'x') === (range.to | dayjsFormat:'x'))"
          [class.day-box--today]="date.isToday"
          [class.day-box--next-month]="date.isNextMonth"
          [class.day-box--last-month]="date.isLastMonth"
          [class.day-box--sunday]="date.isSunday"
          [class.day-box--current-month]="date.isCurrentMonth"
          [attr.data-date]="date.date | dayjsFormat"
          (click)="rangeChange(date.date)"
        >
          {{ date.date | dayjsFormat:'DD' }}
        </button>
      }
    </div>
  </div>
</ng-template>

<ng-template #monthsView>
  <div class="view">
    @if (!isDayMonthView) {
      <div class="separator"></div>
    }
    <div class="months flex-wrap justify-content-center">
      @for (month of months; track i; let i = $index;) {
        <button
          type="button"
          [disabled]="(minDate && ((i + 1) < +(minDate | dayjsFormat:'M')) && ((currentDateToShow | dayjsFormat: 'YYYY') === (minDate | dayjsFormat: 'YYYY')) ) || (maxDate && ((i + 1) > +(maxDate | dayjsFormat:'M')) && ((currentDateToShow | dayjsFormat: 'YYYY') === (maxDate | dayjsFormat: 'YYYY'))) || (minDate && ((currentDateToShow | dayjsFormat: 'YYYY') < (minDate | dayjsFormat: 'YYYY'))) || (maxDate && ((currentDateToShow | dayjsFormat: 'YYYY') > (maxDate | dayjsFormat: 'YYYY')))"
          class="month-box p3"
          [class.selected]="selectedVal && (i + 1 === +(selectedVal | dayjsFormat:'M'))"
          [attr.data-month]="i + 1"
          (click)="monthChange(i)"
        >
          {{ i | monthNumberToName:'MMM' | uppercase }}
        </button>
      }
    </div>
  </div>
</ng-template>

<ng-template #yearsView>
  <div class="view">
    <div class="separator"></div>

    <div class="years d-flex flex-wrap justify-content-center">
      @for (year of years; track year;) {
        <button
          type="button"
          [disabled]="(minDate && (year < +(minDate | dayjsFormat:'YYYY'))) || (maxDate && (year > +(maxDate | dayjsFormat:'YYYY')))"
          class="year-box p3"
          [class.selected]="selectedVal && (year === +(selectedVal | dayjsFormat:'YYYY'))"
          [attr.data-year]="year"
          (click)="yearChange(year)"
        >
          {{ year }}
        </button>
      }
    </div>
  </div>
</ng-template>

<ng-template #kwView>
  <div class="view">
    <div class="d-flex justify-content-center week-days kw">
      <div class="day-box">
        <p class="p3 semibold">KW</p>
      </div>
      @for (day of weekDays; track day) {
        <div class="day-box">
          {{ day }}
        </div>
      }
    </div>
    <div class="separator"></div>

    <div class="days d-flex">
      <div>
        @for (cinemaWeek of cinemaWeeks; track i; let i = $index;) {
          <div
            class="day-box day-box--kw"
            [attr.data-from]="cinemaWeek.from | dayjsFormat"
            [attr.data-to]="cinemaWeek.to | dayjsFormat"
            [attr.data-week]="cinemaWeek.week"
            [class.selected]="cinemaWeek.week === selectedCinemaWeek.week && (((currentDateToShow | dayjsFormat:'YYYY') === (selectedCinemaWeek.from | dayjsFormat:'YYYY')) || ((currentDateToShow | dayjsFormat:'YYYY') === (selectedCinemaWeek.to | dayjsFormat:'YYYY')))"
          >
            {{ cinemaWeek.week }}
          </div>
        }
      </div>
      <div class="d-flex flex-wrap">
        @for (date of datesToRender; track i; let i = $index;) {
          <button
            [disabled]="((minDate && (((date.date | kw).from | dayjsFormat:'x') < ((minDate | kw).from | dayjsFormat:'x'))) || (maxDate && ((date.date | kw).from | dayjsFormat:'x') > ((maxDate | kw).from | dayjsFormat:'x')))"
            class="day-box"
            [class.disabled]="!date.isCurrentMonth"
            [class.from]="(range.from && (date.date | dayjsFormat:'x') === (range.from | dayjsFormat:'x'))"
            [class.to]="(range.to && (date.date | dayjsFormat:'x') === (range.to | dayjsFormat:'x'))"
            [class.hover]="currentHoveredCinemaWeek === (date.date | kw).week"
            [class.active]="currentFocusedCinemaWeek === (date.date | kw).week"
            [class.day-box--today]="date.isToday"
            [class.day-box--next-month]="date.isNextMonth"
            [class.day-box--last-month]="date.isLastMonth"
            [class.day-box--sunday]="date.isSunday"
            [class.day-box--current-month]="date.isCurrentMonth"
            [attr.data-date]="date.date | dayjsFormat"
            [attr.data-cinema-week]="(date.date | kw).week"
            [class.selected]="((date.date | kw).week === selectedCinemaWeek.week) && ((((date.date | kw).from | dayjsFormat:'YYYY') === (selectedCinemaWeek.from | dayjsFormat:'YYYY')) || (((date.date | kw).to | dayjsFormat:'YYYY') === (selectedCinemaWeek.to | dayjsFormat:'YYYY')))"
            (click)="cinemaWeekChange(date.date)"
            (mouseenter)="onCinemaWeekMouseEnter(date.date)"
            (mouseout)="onCinemaWeekMouseOut()"
            (focus)="onCinemaWeekFocus(date.date)"
            (blur)="onCinemaWeekBlur()"
          >
            {{ date.date | dayjsFormat:'DD' }}
          </button>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #yearInputView>
  <input
    type="text"
    class="placeholder-input"
    #inputElement
    [(ngModel)]="inputValue"
    (ngModelChange)="formatSelectedVal($event, pickerType)"
    [ngModelOptions]="{ updateOn: 'blur' }"
    (keydown.enter)="inputElement.blur()"
    [disabled]="isDisabled"
  >
</ng-template>

<ng-template #dayInputView>
  <input
    type="text"
    #inputElement
    [disabled]="isDisabled"
    class="placeholder-input"
    [(ngModel)]="inputValue"
    (mousedown)="inputSelectionStart = inputElement.selectionStart"
    (dblclick)="onInputDblclick(inputElement)"
    (ngModelChange)="formatSelectedVal($event, pickerType)"
    (keydown.enter)="inputElement.blur()"
    [ngModelOptions]="{ updateOn: 'blur' }"
  >
</ng-template>
